const SET_EXTRA_ARGUMENT = 'KH_THUNKED/set-extra-argument'

/**
 * Action creator to set the extra argument passed to thunk bodies. The value
 * passed into this action creator with completely replace the existing extra
 * argument.
 *
 * @param {*} extra - Extra argument, typically an object
 * @returns {Object} - Redux action to set extra argument value.
 */
export const setExtraArgument = extra => ({
  type: SET_EXTRA_ARGUMENT,
  extra,
})

/**
 * A Redux middleware that's identical to redux-thunk, and also allows passing
 * of an extra argument to thunk bodies, but it also allows changing the
 * argument after store instantiation.
 *
 * @param extraArgument {*} - Initial value of the extra thunk argument
 * @returns {Function} - Redux thunk middleware instance
 */
export default function createThunkedMiddleware(extraArgument) {
  let extra = extraArgument

  const middleware = ({ dispatch, getState }) => next => action => {
    if (action.type === SET_EXTRA_ARGUMENT) {
      extra = action.extra
      return getState()
    }
    if (typeof action === 'function') {
      return action(dispatch, getState, extra)
    }
    return next(action)
  }
  return middleware
}
